import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Comment } from './Comment';
import { UrlSignature } from '../common/apiEndpoint';

@Injectable()
export class CommentsService {
  constructor(
    private httpClient: HttpClient,
    private urlSignature: UrlSignature,
  ) { }

  getCommentsForSignUpApplicant(appplicantId): Observable<Comment[]> {
    const url = this.urlSignature.commentUrl + '/' + appplicantId;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Comment[]));
  }

  addCommentsForSignUpApplicant(comment: Comment): Observable<Response> {
    const url = this.urlSignature.commentUrl
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    let data = JSON.stringify(comment);
    return this.httpClient
      .post(url, data, httpOptions)
      .pipe(map((response) => response as Response));
  }

  getApplicantsCommentsExcelFile(applicantId:string): Observable<Blob> {

    const url = this.urlSignature.applicantCommentsExcel+applicantId
    return this.httpClient.get(url, { responseType: 'blob' })
  }
}
